import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export interface GroupProps extends React.ComponentPropsWithoutRef<'div'> {
    innerRef?: React.Ref<HTMLDivElement>;
}

export const Group: React.FC<GroupProps> = ({ innerRef, className, children, ...rest }) => (
    <div ref={innerRef} className={cx('g-group', className)} {...rest}>
        {children}
    </div>
);

Group.displayName = 'Group';
Group.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};
